import { useEffect, useState } from "react";
import SiteHeader from "./components/SiteHeader";
import { useVisualEffects } from "./hooks/useVisualEffects";
import type { Locale } from "./types";
import {
  BusinessSection,
  ClosingSection,
  CompetitionSection,
  FinancialsSection,
  FundingSection,
  HeroSection,
  MarketSection,
  ProblemSection,
  ProductSection,
  ProgressSection,
  RisksSection,
  RoadmapSection,
  SolutionSection,
  TeamSection,
  WhyNowSection,
} from "./sections";

function getInitialLocale(): Locale {
  try {
    return window.localStorage.getItem("agentnexus-locale") === "en" ? "en" : "zh";
  } catch {
    return "zh";
  }
}

export default function App() {
  const [locale, setLocale] = useState<Locale>(getInitialLocale);
  useVisualEffects();

  useEffect(() => {
    document.documentElement.lang = locale === "zh" ? "zh-CN" : "en";
    document.title =
      locale === "zh"
        ? "AgentNexus — AI Agent原生加密货币交易所"
        : "AgentNexus — AI Agent-native cryptocurrency exchange";
    try {
      window.localStorage.setItem("agentnexus-locale", locale);
    } catch {
      // Language switching remains available if storage is blocked.
    }
  }, [locale]);

  return (
    <>
      <a className="skip-link" href="#main">{locale === "zh" ? "跳至主要内容" : "Skip to main content"}</a>
      <SiteHeader locale={locale} setLocale={setLocale} />
      <main id="main">
        <HeroSection locale={locale} />
        <ProblemSection locale={locale} />
        <SolutionSection locale={locale} />
        <ProductSection locale={locale} />
        <WhyNowSection locale={locale} />
        <MarketSection locale={locale} />
        <BusinessSection locale={locale} />
        <CompetitionSection locale={locale} />
        <RoadmapSection locale={locale} />
        <ProgressSection locale={locale} />
        <TeamSection locale={locale} />
        <FinancialsSection locale={locale} />
        <FundingSection locale={locale} />
        <RisksSection locale={locale} />
        <ClosingSection locale={locale} />
      </main>
    </>
  );
}
